
import { VideoFeatures } from '@/store/videoFeatures';

// Helper function to check if a feature is configured - Added null checks
export const isFeatureConfigured = (features: VideoFeatures, featureId: string): boolean => {
  if (!features) return false;
  
  switch (featureId) {
    case 'controls':
      return features.showControls === true;
    case 'progressBar':
      return features.progressBar?.enabled === true;
    case 'loop':
      return features.loop === true;
    case 'headline':
      return features.headline?.enabled === true;
    case 'thumbnail':
      return (features.thumbnail?.enabled === true) || 
             (features.initialThumbnail?.enabled === true) || 
             (features.pauseThumbnail?.enabled === true) || 
             (features.endThumbnail?.enabled === true);
    case 'actionButton':
      return (features.actionButtons ?? []).some((button) => button.enabled === true);
    case 'playbackSpeed':
      return features.playbackSpeed !== undefined && features.playbackSpeed !== 1;
    case 'audience':
      return features.audience !== undefined && features.audience.enabled === true;
    case 'continueWatching':
      return features.continueWatching !== undefined && features.continueWatching.enabled === true;
    case 'border':
      return features.enableBorder === true || (features.border !== undefined && features.border.enabled === true);
    case 'logo':
      return features.logo !== undefined && features.logo !== null && features.logo.enabled === true;
    case 'pixel':
      return features.pixelTracking !== undefined && (
        Array.isArray(features.pixelTracking)
          ? features.pixelTracking.length > 0 && features.pixelTracking[0]?.enabled === true
          : features.pixelTracking?.enabled === true
      );
    // OCULTO TEMPORARIAMENTE - Será implementado futuramente
    // case 'affiliate':
    //   return features.affiliate !== undefined && features.affiliate.enabled === true;
    case 'smartPause':
      return features.smartPause === true;
    case 'haveRestart':
      return features.haveRestart === true;
    case 'subtitles':
      return (features.subtitleConfig?.showByDefault === true) || ((features.subtitles?.length ?? 0) > 0);
    case 'autoplayOverlay':
      return features.autoplayOverlay !== undefined && features.autoplayOverlay.enabled === true;
    case 'salesNotification':
      return features.salesNotification !== undefined && features.salesNotification.enabled === true;
    case 'responsivePlayer':
      return !!features.responsivePlayer?.enabled;
    case 'miniHooks':
      return features.miniHooks?.enabled === true;
    case 'conversionJourney':
      return features.conversionJourney?.enabled === true;
    case 'videoFeedback':
      return features.videoFeedback?.enabled === true;
    case 'finalCountdown':
      return features.finalCountdown?.enabled === true;
    default:
      return false;
  }
};
